// 22.01.19 - This is used by Saga for the form_wrapper.
import axios from "axios";

import {
  ICase,
  UPDATE_CASE,
  SAVE_CASE,
  SAVE_ATTACHMENT_DATA,
  DOWNLOAD_ATTACHMENT,
  DELETE_ATTACHMENT,
  CASE_LOCK_UNLOCK,
  CASE_LOCK_FOR_EDIT,
  REQUEST_FOR_CLOSE,
  SAVE_SP_USER,
} from "../../constants/api";
import { getCurrentUser, getLoggedInCurrentUserDetails } from "src/utils";

export const updateCaseUtility = async (theCase: ICase) => {
  try {
    const response = await axios.put(
      // UPDATE_CASE + "/" + theCase.uniqueId,
      UPDATE_CASE + theCase.uniqueId,
      theCase
    );
    return response.data;
  } catch (e) {
    return {
      message: e.toString(),
      success: false,
    };
  }
};

export const saveCaseUtility = async (theCase: ICase) => {
  try {
    const response = await axios.post(SAVE_CASE, theCase);
    return response.data;
  } catch (e) {
    return {
      message: e.toString(),
      success: false,
    };
  }
};

/**
 * Function for saving attachments to server directory
 * @param data File data
 */
export const saveAttachmentDataUtility = (data: any) => {
  const formData = new FormData();

  formData.append("CaseUniqueId", data.uniqueId);
  formData.append("Type", data.type);
  // formData.append('uploadedBy', data.uploadedBy);

  data.file.forEach((item: any) => {
    formData.append("files", item);
  });

  return axios
    .post(SAVE_ATTACHMENT_DATA, formData, {
      headers: {
        enctype: "multipart/form-data",
        "Content-Type": "multipart/form-data",
      },
    })
    .then(
      (resp) => {
        return resp;
      },
      (err) => {
        return err;
      }
    );
};

/**
 * Function for downloading an attachment
 */
export const downloadAttachmentUtility = (fileId: any) => {
  const url = `${DOWNLOAD_ATTACHMENT}/${fileId}`;
  return axios.get(url).then(
    (resp: any) => {
      return resp.data;
    },
    (err: any) => {
      return err;
    }
  );
};

/**
 * Function for deleteing an attachment
 */
export const deleteAttachmentUtility = (fileId: any) => {
  const url = `${DELETE_ATTACHMENT}/${fileId}`;
  return axios.post(url).then(
    (resp: any) => {
      return resp.data;
    },
    (err: any) => {
      return err;
    }
  );
};

/**
 * Function to check whether a case is locked or open for editing
 */
export const caseLockUnlockUtility = (uniqueId: string, username: any) => {
  const url = `${CASE_LOCK_UNLOCK}/${uniqueId}/${username}`;
  return axios.post(url).then(
    (resp: any) => {
      return resp.data;
    },
    (err: any) => {
      return err;
    }
  );
};

/**
 * Function to check whether a case is locked or open for editing
 */
export const caseLockForEditUtility = (uniqueId: string, isEdit: boolean, updatedBy: string) => {
  const url = `${CASE_LOCK_FOR_EDIT}/${uniqueId}/${isEdit}/${updatedBy}`;
  return axios.post(url).then(
    (resp: any) => {
      return resp.data;
    },
    (err: any) => {
      return err;
    }
  );
};

/**
 * Function to request a case closed by Solution Owner or Team
 */
export const requestForCloseUtility = (caseData: any, currentUser: any) => {
  const url = `${REQUEST_FOR_CLOSE}`;
  const { uniqueId, caseNo } = caseData;
  const { userName, role } = currentUser;

  // Fetch the name of the logged in user
  const userToken = localStorage.getItem("msal.idtoken");
  //const userDetails = getCurrentUser(userToken);
  const userDetails = getLoggedInCurrentUserDetails(currentUser);

  const requestBody = {
    uniqueId,
    caseNo,
    requestedByName: userDetails.name,
    requestedByEmail: userName,
    requestedByRole: role.name,
  };
  return axios.post(url, requestBody).then(
    (resp: any) => {
      return resp.data;
    },
    (err: any) => {
      return err;
    }
  );
};

export const apiSaveSPUserData = async (data: any) => {
  const url = `${SAVE_SP_USER}`;
  const response = await axios.post(`${url}`, data);
  return response;
};
